module.exports = __webpack_public_path__ + "static/img/dna_gif.1b486c86.gif";